import type { DegreeImageRightClientProps } from "./types";
import ImageRight from "@/components/ContentBlock/variants/ImageRight";
import { getDegreeImage } from "./utils";

export default function DegreeImageRightWrapper({
  className,
  children,
  section,
  useContainer,
  uuid,
}: DegreeImageRightClientProps) {
  const degreeImageData = getDegreeImage(uuid, section);

  return (
    <div>
      <ImageRight
        imageurl={degreeImageData.imageurl}
        imagetitle={degreeImageData.imagetitle}
        height={degreeImageData.height}
        width={degreeImageData.width}
        className={className}
        accentColor={degreeImageData.brandColor}
        useContainer={useContainer}
        reverseVertical={false}
        responsiveImage={!!degreeImageData.imageurl}
      >
        {children}
      </ImageRight>
    </div>
  );
}
